export default __webpack_public_path__ + "static/media/expertise_s.4cfc5ec3.jpg";